import * as React from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';

import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import {useLocation, useNavigate} from 'react-router-dom';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import FlatwareIcon from '@mui/icons-material/Flatware';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import api from "../../utils/api";
import {FormContainer, TextFieldElement} from 'react-hook-form-mui';
import {useEffect} from "react";
import * as util from "../../utils/util";
import { Divider } from '@mui/material';
import { notifyApiError } from "../../utils/apiError";

const counselInit = {
  id: '',
  title: '',
  content: '',
  createDate: '',
  answer: '',
  type: '',
  category: '',
  answerDate: '',
  memberId: '',
  image_url: ''
}

const CreateCounsel = () => {
  const navigate = useNavigate();
  const [alignment, setAlignment] = React.useState('EXERCISE');
  const [contentLength, setContentLength] = React.useState(0);
  const [counsel, setCounsel] = React.useState(counselInit);
  const {state} = useLocation();
  const {supportId} = state ?? {};

  useEffect(() => {
    if(supportId > 0){  // 수정을 통해 들어왔을 때, 기존 상담 정보 조회
      getCounsel();
    }
  }, []);
    
  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };
  
  function getCounsel(){
    api.get(`app/api/v1/AP_003_002?support_id=${supportId}`).then(res => {
      setCounsel(res.data.result_data.support_item);
      setContentLength(res.data.result_data.support_item.content.length);
      setAlignment(res.data.result_data.support_item.category);
    }).catch(function (error) {
      console.log(error)
    });
  }
  
  function handleClickCreateCounsel(data: any){
    data.cid = supportId;
    data.type = 'MY';
    data.category = alignment;
    data.image_url = '';
    
    api.post(`app/api/v1/AP_003_003`, data).then((res: any) => {
      alert('상담 등록이 완료되었습니다.');
      navigate('/check/Counsel');
    }).catch(function (error) {
      // 저장 실패를 알리지 않으면 사용자는 기록이 남은 줄 안다
      notifyApiError(error, '상담 신청을 접수하지 못했습니다.');
    });
  }
  


  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', pt: 10, pb: 10, minWidth: 320 }}>
      <Top title='상담 등록' />

      <FormContainer
        values={{cid: counsel.id, category: counsel.category, 
          title: counsel.title, content: counsel.content, type: counsel.type, image_url: counsel.image_url}}
        onSuccess={data => handleClickCreateCounsel(data)}
      >
        
        <Stack direction="row" spacing={0} sx={{ mt: 2 }}>
          <ToggleButtonGroup
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="counsel"
            sx={{ width: '100%', bgcolor:'#fff' }}
          >
  
            <ToggleButton value="EXERCISE" key="EXERCISE" aria-label="EXERCISE" sx={toggleBtn}>
              <FitnessCenterIcon fontSize='small' />
              <Typography>운동</Typography>
            </ToggleButton>
            <ToggleButton value="HEALTH" key="HEALTH" aria-label="HEALTH" sx={toggleBtn}>
              <HealthAndSafetyIcon fontSize='small' />
              <Typography>건강</Typography>
            </ToggleButton>
            <ToggleButton value="DIET" key="DIET" aria-label="DIET" sx={toggleBtn}>
              <FlatwareIcon fontSize='small' />
              <Typography>식이</Typography>
            </ToggleButton>
  
          </ToggleButtonGroup>
        </Stack>
  
        
        <Box
          component="form"
          sx={{
            mt: 4,
            '& > :not(style)': { m: 0, mb: 3, width: '100%' },
          }}
          noValidate
          autoComplete="off"
        >
          <TextFieldElement
            name="title"
            id="input-title" label="제목"
            fullWidth
            onChange={(e :any) => {
              setCounsel((prev) => true ? {...prev, title: e.target.value} : prev);
            }}
            multiline
            maxRows={2}
            inputProps={{ maxLength: 50, value: counsel.title }}
            rules={{
              required: '제목은 필수 입력입니다.',
            }}
            sx={{
              '& .MuiInputBase-root': {bgcolor:'#fff'},
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused' : {color:'#ec8122'},
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline' : {borderColor:'#ec8122'}
            }}
          />
          <TextFieldElement
            name="content"
            id="input-content" label="내용"
            fullWidth
            onChange={(e :any) => {
              setCounsel((prev) => true ? {...prev, content: e.target.value} : prev);
              setContentLength(e.target.value.length);
            }}
            multiline
            rows={12}
            inputProps={{ maxLength: 250, value: counsel.content }}
            rules={{
              required: '내용은 필수 입력입니다.',
            }}
            sx={{
              '& .MuiInputBase-root': {bgcolor:'#fff'},
              '& .MuiFormLabel-root.MuiInputLabel-root.Mui-focused' : {color:'#ec8122'},
              '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline' : {borderColor:'#ec8122'}
            }}
          />
        </Box>
        <Typography sx={{fontSize:12, color:'#777', textAlign:'right', mt:-2}}>({contentLength}/250자)</Typography>
          
          
        {/*
        <Divider  sx={{my:4}} />
        
        <Box>
          <Typography sx={{fontSize:16, mb:2 }}>사진 첨부 <Typography component={'span'} sx={{fontSize:14, color:'#888'}}>(선택)</Typography> </Typography>
          <form>
            <Typography sx={labelStyle}>이미지 추가</Typography>
            <Input
              type="file"
              id="fileImg"
              //sx={inputStyle}
            />
          </form>
          <Typography sx={{fontSize:12, color:'#777', mt:1}}>사진 1장 등록 가능</Typography>
        </Box>
       */}
  
        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle} type={'submit'}>
            등록
          </Button>
        </Box>

      </FormContainer>
      
      <Bottom />
    </Container>
  );
}



const toggleBtn = {
  p: 1,
  flex: '1 1 auto',
  '& .MuiSvgIcon-root': { pl: 1 },
  '& p': { fontSize: 14, pl: 1, pr: 1 },
  '&.Mui-selected': { bgcolor:'#ec8122!important'},
  '&.Mui-selected svg': { color:'#fff'},
  '&.Mui-selected p': { fontWeight: 700, color:'#fff' }
}

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 3,
  boxSizing: 'border-box',
  pb: 3
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

const labelStyle = {
  display: 'inline-block',
  width: '90px',
  height: '90px',
  background: 'url("src/assets/icon-add-photo.svg") no-repeat',
  backgroundPosition: 'center',
  border: '1px solid #ccc',
  borderRadius: '10px',
  cursor: 'pointer',
}

// const inputStyle= {
//   display: 'none'
// }

export default CreateCounsel;